var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-lg"},[_c('Nav'),_c('main',{attrs:{"id":"main"}},[_c('Sidenav'),_c('div',{staticClass:"col offset-3 p-0 deneme"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }